import { createRoot } from 'react-dom/client';
import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ErrorBoundary } from './errorBoundary';
import { initSentry } from './services/sentry';

const queryClient = new QueryClient();

initSentry();

window.app = (function createApp() {
  const views = {};
  const controllers = {};
  const models = {};

  return {
    view,
    controller,
    model,
    getAll,
  };

  function getAll(typeName, match = /.*/) {
    const componentTypes = {
      view: views,
      controller: controllers,
      model: models,
    };

    const componentMap = componentTypes[typeName];

    return Object.keys(componentMap || {}).reduce((dict, key) => {
      if (key.match(match)) {
        dict[key] = componentMap[key];
      }
      return dict;
    }, {});
  }

  function view(name, view) {
    return base(views, name, view);
  }

  function controller(name, controller) {
    return base(controllers, name, controller);
  }

  function model(name, model) {
    return base(models, name, model);
  }

  function base(collection, name, obj) {
    if (obj) {
      collection[name] = obj;
    } else {
      if (!collection[name]) {
        throw new Error('Warning. Could not find ' + name);
      } else return collection[name];
    }
  }
})();

export default function() {
  const siteSpecificTypes = window.leazardGlobalTypes || {};

  app.controller('form:begin', begin);

  window.globalCounter = {};

  function begin(elementId, incomingConfig = {}, callback = (a) => a) {
    const tools = require('form/tools')(elementId);
    const translate = require('form/translate')(incomingConfig.language || 'norwegian', incomingConfig['language-override']);
    const types = require('form/types').types(tools, siteSpecificTypes, translate);

    const config = require('form/config').config(incomingConfig, types, translate);
    const state = require('form/state').state(config, types, translate);

    const errorCheckers = require('form/errorCheckers').checkers(state, config);

    const Form = require('form/leazard').default({
      config: config,
      reload: () => update(),
      tools: tools,
      types: types,
      language: translate,
    });

    state.fields.forEach((field) => {
      field.state.enabled = null;
    });

    const root = createRoot(document.getElementById(elementId));

    update();

    function update(checkApi = true) {
      makeGlobalState(state);

      errorCheckers(checkApi ? update : null);

      root.render(
        <ErrorBoundary language={translate}>
          <QueryClientProvider client={queryClient}>
            <Form state={state} />
          </QueryClientProvider>
        </ErrorBoundary>
      );
    }

    function makeGlobalState(state) {
      state.fields.forEach((field) => {
        field.state.enabled = null;
      });

      state.globalState = tools.makeGlobalState(state, config);

      state.fields.forEach((field) => {
        field.state.enabled = null;
      });

      return state.globalState;
    }
  }
}
